import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { API_RBAC_ROLES } from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_ROLES = 'SET_ROLES';

const initialState = [];

// ------------------------------------
// Actions
// ------------------------------------
const setRoles = createAction(SET_ROLES);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_ROLES]: (state, { payload }) => {
    return payload;
  },
};

export const getRoles = dispatch =>
  http.get(API_RBAC_ROLES).then(({ data }) => {
    dispatch(setRoles(data));
    return data;
  });

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearRoles = () => setRoles(initialState);
